import $ from "jquery"
import { figureChecked } from "./sendmail"
import { getOptions } from "./variables"
import { mfpb } from "./mfpTootls"

export function mfpc(formId, name, fb_govm, fb_city, fb_town) {
  const { obj, getpostcode_cgi } = getOptions()

  const elem = obj.elements[name]

  ;["-", "－", "ー", "―", "ｰ", "‐"].map((c) => {
    elem.value = elem.value.replace(c, "")
  })

  if (elem.value == "" || !figureChecked(elem.value)) return false

  elem.value = figureChecked(elem.value)

  $.get(getpostcode_cgi + encodeURI(elem.value), (getAddress) => {
    const getAddressGroup = getAddress.split(",")
    if (getAddressGroup.length === 3) {
      obj.elements[fb_govm].value = getAddressGroup[0]
      obj.elements[fb_city].value = `${getAddressGroup[1]}${getAddressGroup[2]}`
      //      obj.elements[fb_town].value =
      mfpb(obj.elements[fb_govm])
      mfpb(obj.elements[fb_city])
      mfpb(obj.elements[fb_town])
    }
  })

  return false
}
